module.exports = __webpack_public_path__ + "assets/img/btn-download-xbox-bfe495d2.png";